import type { FC } from "react";

import { useUser } from "@ui/hooks/useUser";
import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { useConfig } from "@jti/app-context/useConfig";

import { getFullUserName } from "../../utils/getFullUserName";

import styles from "./UserIndicationButton.module.scss";

export const UserIndicationButtonMobile: FC = () => {
  const { user, isUserLoggedIn } = useUser();
  const { isSingleNameField, isReversedNameOrder } = useConfig();
  const { __ } = useTranslations();
  const userName = getFullUserName(__, user, isSingleNameField, isReversedNameOrder);

  if (!isUserLoggedIn) {
    return null;
  }

  return (
    <div className={styles.navigationUsername}>
      <div className={styles.userButtonWrapperMobile}>
        <div className={classNames(styles.userButton)}>
          <div
            className={classNames(styles.userButtonLogged, styles.userButtonLoggedNordic, styles.userLetterWithName)}
          >
            {userName?.[0]?.toLocaleUpperCase()}
          </div>
        </div>
        <span className={styles.userButtonNameMobile}>{userName}</span>
      </div>
    </div>
  );
};
